<!--<div class="btn-group" [classList]="classesString" #dropdown="bs-dropdown" dropdown [autoClose]="false" container=".content-wrapper">-->
<div
  class="btn-group"
  [classList]="classesString"
  #dropdown="bs-dropdown"
  dropdown
  [autoClose]="false"
  [container]="container"
>
  <button dropdownToggle type="button" class="btn dropdown-toggle dropdown-settings btn-{{ theme }}">
    <i *ngIf="icon && icon.length" [class]="iconClassesString"></i>
    {{ label | translate }}
  </button>
  <ul *dropdownMenu class="dropdown-menu" [ngClass]="{ 'dropdown-settings-list': isSwitchList }" role="menu">
    <ng-template [ngIf]="items && items.length">
      <button
        class="dropdown-item"
        [ngClass]="{ selected: item.isSelected }"
        *ngFor="let item of items"
        (click)="onItemClick(item.action)"
      >
        {{ item.label | translate }}
        <span class="styled-switch" *ngIf="isSwitchList">
          <span class="styled-switch-slider"></span>
        </span>
      </button>
    </ng-template>
  </ul>
</div>
